<!-- 分享-海报页 -->
<template>
  <div class="poster-page">
    <div class="top">
      <div class="title">孩子到校，家长知道</div>
    </div>
    <div class="center">
      <img class="img" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/face/002.png" />
      <div class="desc">推荐你免费使用这款APP，孩子刷脸签到，家长自动收到消息，我们都放心。</div>
    </div>
    <div class="btn" @click="gotoDownApp">点击了解更多</div>
  </div>
</template>

<script>
export default {
  name: 'poster',
  data() {
    return {
      pageTitle: '脸到app',
      appStoreUrl: '',
      channelType: this.$route.query.channelType,
    };
  },
  methods: {
    sendStatistics(eventType = 1) {
      this.$api.addChannelStatistics({
        pageId: '4',
        pageName: '脸到分享下载页',
        channelType: this.channelType || 1,
        eventType: eventType,
      });
    },
    gotoDownApp() {
      if (app.base.isIos) {
        this.sendStatistics(3);
        //苹果跳下载链接
        window.open('https://itunes.apple.com/cn/app/id1571838977');
      } else {
        this.sendStatistics(2);
        //安卓跳下载链接
        window.location.href = this.androidApkUrl;
      }
      location.href = this.appStoreUrl;
    },
  },
  async created() {
    this.sendStatistics(1);
    let res = await this.$api.getAppstoreUrl();
    this.appStoreUrl = res.data;
  },
};
</script>

<style lang="scss" scoped>
.poster-page {
  // padding: 145px 36px 0 36px;
  padding: 32px 0;
  background: linear-gradient(225deg, #feba00 0%, #ffdb00 100%);
  .top {
    // position: absolute;
    // top: 32px;
    // left: 0;
    // right: 0;
    height: 154px;
    z-index: 1;
    background: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/face/001.png) center/cover
      no-repeat;
    .title {
      position: relative;
      display: inline-block;
      margin: 56px 0 0 38px;
      color: var(--white);
      font-size: 24px;
      line-height: 33px;
      &::before {
        content: '';
        height: 11px;
        background: rgba(255, 255, 255, 0.2);
        position: absolute;
        bottom: 0px;
        left: 0;
        right: 0;
        display: block;
      }
    }
  }
  .center {
    z-index: 22;
    padding: 29px 0 20px 0;
    margin: -36px 36px 0 36px;
    border-radius: 14px;
    background-color: var(--white);
    text-align: center;
    .img {
      width: 214px;
      height: 214px;
    }
    .desc {
      color: #34280e;
      position: relative;
      margin: 13px 16px 0 16px;
      padding: 12px;
      text-align: left;
      background-color: #fff2df;
      &::before {
        position: absolute;
        bottom: -10px;
        right: 10px;
        content: '';
        display: block;
        width: 0;
        height: 0;
        border-top: 10px solid #fff2df;
        border-right: 10px solid transparent;
      }
    }
  }
  .btn {
    margin: 32px 36px;
    padding: 12px 0;
    text-align: center;
    border-radius: 6px;
    color: #feb200;
    background-color: var(--white);
  }
}
</style>